module.exports = __webpack_public_path__ + "static/media/izlozba (13).c0658450.jpg";